import React, { useState } from 'react';

import { Button } from './LoadMore.styles';

const LoadMore = ({
  nextPage,
  id,
  episodes,
  setLoadedEpisodes,
  setNextPage
}) => {
  const [loading, setLoading] = useState(false);
  const handleClick = () => {
    setLoading(true);
    const fetchData = async () => {
      let url = `https://listen-api.listennotes.com/api/v2/podcasts/${id}?next_episode_pub_date=${nextPage}`;
      const res = await fetch(url, {
        headers: {
          'X-ListenAPI-Key': process.env.REACT_APP_XLISTEN_API_KEY
        }
      });
      const dataObject = await res.json();
      setLoadedEpisodes([...episodes, ...dataObject.episodes]);
      setNextPage(dataObject.next_episode_pub_date);
      setLoading(false);
    };
    fetchData().catch(err => console.error(err));
  };

  return (
    <Button onClick={handleClick}>
      {loading ? 'Loading...' : 'More episodes'}
    </Button>
  );
};

export default LoadMore;
